export const audio = {
    'audio/3gpp': {
        extensions: ['3gpp'],
        source: 'iana',
    },
    'audio/adpcm': {
        extensions: ['adp'],
        source: 'apache',
    },
    'audio/amr': {
        extensions: ['amr'],
        source: 'iana',
    },
    'audio/basic': {
        extensions: ['au', 'snd'],
        source: 'iana',
    },
    'audio/midi': {
        extensions: ['mid', 'midi', 'kar', 'rmi'],
        source: 'apache',
    },
    'audio/mobile-xmf': {
        extensions: ['mxmf'],
        source: 'iana',
    },
    'audio/mp4': {
        extensions: ['m4a', 'mp4a'],
        source: 'iana',
    },
    'audio/mpeg': {
        extensions: ['mpga', 'mp2', 'mp2a', 'mp3', 'm2a', 'm3a'],
        source: 'iana',
    },
    'audio/ogg': {
        extensions: ['oga', 'ogg', 'spx', 'opus'],
        source: 'iana',
    },
    'audio/s3m': {
        extensions: ['s3m'],
        source: 'apache',
    },
    'audio/silk': {
        extensions: ['sil'],
        source: 'apache',
    },
    'audio/vnd.dece.audio': {
        extensions: ['uva', 'uvva'],
        source: 'iana',
    },
    'audio/vnd.digital-winds': {
        extensions: ['eol'],
        source: 'iana',
    },
    'audio/vnd.dra': {
        extensions: ['dra'],
        source: 'iana',
    },
    'audio/vnd.dts': {
        extensions: ['dts'],
        source: 'iana',
    },
    'audio/vnd.dts.hd': {
        extensions: ['dtshd'],
        source: 'iana',
    },
    'audio/vnd.lucent.voice': {
        extensions: ['lvp'],
        source: 'iana',
    },
    'audio/vnd.ms-playready.media.pya': {
        extensions: ['pya'],
        source: 'iana',
    },
    'audio/vnd.nuera.ecelp4800': {
        extensions: ['ecelp4800'],
        source: 'iana',
    },
    'audio/vnd.nuera.ecelp7470': {
        extensions: ['ecelp7470'],
        source: 'iana',
    },
    'audio/vnd.nuera.ecelp9600': {
        extensions: ['ecelp9600'],
        source: 'iana',
    },
    'audio/vnd.rip': {
        extensions: ['rip'],
        source: 'iana',
    },
    'audio/webm': {
        extensions: ['weba'],
        source: 'apache',
    },
    'audio/x-aac': {
        extensions: ['aac'],
        source: 'apache',
    },
    'audio/x-aiff': {
        extensions: ['aif', 'aiff', 'aifc'],
        source: 'apache',
    },
    'audio/x-caf': {
        extensions: ['caf'],
        source: 'apache',
    },
    'audio/x-flac': {
        extensions: ['flac'],
        source: 'apache',
    },
    'audio/x-gsm': {
        extensions: ['gsm'],
        source: 'apache',
    },
    'audio/x-m4a': {
        extensions: ['m4a'],
        source: 'nginx',
    },
    'audio/x-matroska': {
        extensions: ['mka'],
        source: 'apache',
    },
    'audio/x-mpegurl': {
        extensions: ['m3u'],
        source: 'apache',
    },
    'audio/x-ms-wax': {
        extensions: ['wax'],
        source: 'apache',
    },
    'audio/x-ms-wma': {
        extensions: ['wma'],
        source: 'apache',
    },
    'audio/x-pn-realaudio': {
        extensions: ['ram', 'ra'],
        source: 'apache',
    },
    'audio/x-pn-realaudio-plugin': {
        extensions: ['rmp'],
        source: 'apache',
    },
    'audio/x-realaudio': {
        extensions: ['ra'],
        source: 'nginx',
    },
    'audio/x-wav': {
        extensions: ['wav'],
        source: 'apache',
    },
    'audio/xm': {
        extensions: ['xm'],
        source: 'apache',
    },
} as const;
